import { Controller } from "@hotwired/stimulus"
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import PrimeVue from 'primevue/config'

import {
  Bars3Icon,
  BellIcon,
  CheckIcon,
  ChevronUpDownIcon,
  XMarkIcon,
  Bars3BottomLeftIcon
} from '@heroicons/vue/24/outline'

import {
  DialogPanel,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Listbox,
  ListboxButton,
  ListboxLabel,
  ListboxOption,
  ListboxOptions,
  Menu as UiMenu,
  MenuButton,
  MenuItem,
  MenuItems,
  RadioGroup,
  RadioGroupLabel,
  RadioGroupOption,
  TransitionChild,
  TransitionRoot,
  Dialog as UiDialog,
  SwitchGroup,
  SwitchLabel
} from '@headlessui/vue'

import InlineHelp from "../../../../app/frontend/components/InlineHelp.vue"
import Multiselect from "../../../../app/frontend/components/Multiselect.vue"
import GroupedMultiselect from '../../../../app/frontend/components/GroupedMultiselect.vue'
import SearchForm from "../../../../app/frontend/components/SearchForm.vue"
import SearchFCriterionFields from "../../../../app/frontend/components/SearchCriterionFields.vue"
import ToggleSwitch from "../../../../app/frontend/components/ToggleSwitch.vue"
import PrivacyToggleSwitch from "../../../../app/frontend/components/PrivacyToggleSwitch.vue"
import Bookmark from '../../../../app/frontend/components/Bookmark.vue'
import MorePopover from '../../../../app/frontend/components/MorePopover.vue'
import CalendarPopover from '../../../../app/frontend/components/CalendarPopover.vue'
import SummaryTile from '../../../../app/frontend/components/SummaryTile.vue'

import Tabs from 'primevue/tabs'
import TabList from 'primevue/tablist'
import Tab from 'primevue/tab'
import TabPanels from 'primevue/tabpanels'
import TabPanel from 'primevue/tabpanel'

import AdminUqueryForm from "../../../../app/frontend/components/AdminUqueryForm.vue";

export default class extends Controller {

  connect() {
    const mountPointElement = this.element

    // Apr 2025: this will remount vue to the element that is replaced by turbo stream
    this.app = createApp({
      template: mountPointElement.innerHTML || '<div></div>'
    })

    this.app
      .component('adminuqueryform', AdminUqueryForm)
      .component('bars3bottomlefticon', Bars3BottomLeftIcon)
      .component('bars3icon', Bars3Icon)
      .component('bellicon', BellIcon)
      .component('bookmark', Bookmark)
      .component('calendarpopover', CalendarPopover)
      .component('checkicon', CheckIcon)
      .component('chevronupdownicon', ChevronUpDownIcon)
      .component('dialogpanel', DialogPanel)
      .component('disclosure', Disclosure)
      .component('disclosurebutton', DisclosureButton)
      .component('disclosurepanel', DisclosurePanel)
      .component('groupedmultiselect', GroupedMultiselect)
      .component('inlinehelp', InlineHelp)
      .component('listbox', Listbox)
      .component('listboxbutton', ListboxButton)
      .component('listboxlabel', ListboxLabel)
      .component('listboxoption', ListboxOption)
      .component('listboxoptions', ListboxOptions)
      .component('menubutton', MenuButton)
      .component('menuitem', MenuItem)
      .component('menuitems', MenuItems)
      .component('morepopover', MorePopover)
      .component('multiselect', Multiselect)
      .component('privacytoggleswitch', PrivacyToggleSwitch)
      .component('searchfcriterionfields', SearchFCriterionFields)
      .component('searchform', SearchForm)
      .component('summarytile', SummaryTile)
      .component('switchgroup', SwitchGroup)
      .component('switchlabel', SwitchLabel)
      .component('tab', Tab)
      .component('tablist', TabList)
      .component('tabpanel', TabPanel)
      .component('tabpanels', TabPanels)
      .component('tabs', Tabs)
      .component('toggleswitch', ToggleSwitch)
      .component('transitionchild', TransitionChild)
      .component('transitionroot', TransitionRoot)
      .component('uidialog', UiDialog)
      .component('uimenu', UiMenu)
      .component('xmarkicon', XMarkIcon)

    this.app.use(PrimeVue, { unstyled: true })
    this.app.mount(mountPointElement)

    let controllers = this.element.dataset.controller.split(' ')
    controllers = controllers.filter(c => c !== 'remount')
    this.element.dataset.controller = controllers.join(' ')
  }
}
